module.exports = __webpack_public_path__ + "static/media/AvgSnP500Ret.40ee74eb.png";